import apiClient from '../axios.js'

/**
 * 程式管理 API
 */
export const programService = {
    /**
     * 獲取程式列表
     * @param {Object} params - 查詢參數
     * @param {number} params.page - 頁碼
     * @param {number} params.pageSize - 每頁數量
     * @param {string} params.search - 搜尋關鍵字
     * @param {string} params.status - 狀態（可選）
     * @param {string} params.moduleId - 模組 ID（可選）
     * @returns {Promise<Object>} 程式列表
     */
    getPrograms: async (params = {}) => {
        const response = await apiClient.get('/system/programs', { params })
        return response
    },

    /**
     * 獲取單一程式詳情
     * @param {string} id - 程式 ID
     * @returns {Promise<Object>} 程式詳情
     */
    getProgram: async (id) => {
        const response = await apiClient.get(`/system/programs/${id}`)
        return response
    },

    /**
     * 新增程式
     * @param {Object} programData - 程式資料
     * @returns {Promise<Object>} 新增結果
     */
    createProgram: async (programData) => {
        const response = await apiClient.post('/system/programs', programData)
        return response
    },

    /**
     * 更新程式
     * @param {string} id - 程式 ID
     * @param {Object} programData - 程式資料
     * @returns {Promise<Object>} 更新結果
     */
    updateProgram: async (id, programData) => {
        const response = await apiClient.put(`/system/programs/${id}`, programData)
        return response
    },

    /**
     * 刪除程式
     * @param {string} id - 程式 ID
     * @returns {Promise<Object>} 刪除結果
     */
    deleteProgram: async (id) => {
        const response = await apiClient.delete(`/system/programs/${id}`)
        return response
    },
}
